module.exports = __webpack_public_path__ + "static/icthub-dark-3c20f8fd5ad0a5becf19ae7e14ae7960.png";